<template>
  <div class="about" v-if="tsTitle">
    <van-overlay class="loginOverLay" :show="showLogin" />
    <header>
      <img src="@/assets/background.png">
    </header>
    <div class="cxcz">
      <h3>登录</h3>
    </div>
    <van-form>
      <van-field v-model="form.username" name="username" label="用户名" placeholder="请填写用户名" :rules="[{ required: true}]" />
      <van-field v-model="form.password" type="password" name="password" label="密码" placeholder="请填写密码" :rules="[{ required: true}]" />
     <!-- <van-field name="checkbox" label="是否绑定微信">
        <template #input>
          <van-checkbox v-model="checkbox" icon-size="15px" shape="square" />
        </template>
      </van-field> -->
      <div class="vanBTNS">
        <van-button round block color="#1e5feb" @click="Login">确认登录</van-button>
      </div>
      <div class="btnDown" @click="$router.push('/ForgetPasswordShow')">
        <p>忘记密码？</p>
      </div>
      <!-- <div class="other">
        <div class="btns">
          <div class="Weact">
            <p>其他登录方式：</p>
            <div class="wx" @click="WechatLogin('click')"></div>
          </div>
          <div class="register" @click="$router.push('/register')">
            <p>立刻注册</p>
          </div>
        </div>
      </div> -->
    </van-form>
  </div>
</template>

<script>
import { Login, WechatLogin, WechatLogins, bindWechat, userInfoMobile, AuthorizeMobile, getAppEdition } from '@/api/login.js'
// , IntoIndex
import { initConfig } from '@/api/wxShare.js'
import wx from 'weixin-js-sdk'
export default {
  name: 'LoginVues',
  components: {},
  props: {},
  data () {
    return {
      // 遮罩
      showLogin: false,
      // 账号密码
      form: {
        username: '',
        password: ''
      },
      userId: '',
      userFOM: {},
      token: '',
      openId: '',
      // 判断是否是手动退出账号
      automaticLogin: '',
      // 是否绑定微信
      checkbox: false,
      isFirst: '',
      tsTitle: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 登录接口
    async Login () {
      if (!this.form.username) return this.$toast.fail('请填写账号')
      if (!this.form.password) return this.$toast.fail('请填写密码')
      const { data: res } = await Login({ account: this.form.username, password: this.form.password })
      if (res.code === 1) {
        this.$toast.fail('登录失败,账户或密码不正确')
      } else {
        this.$store.commit('setToken', res.token)
        this.$store.commit('setUserID', res.userId + 'a')
        this.$store.commit('setUserName', res.userName)
        this.$store.commit('setAgentName', res.agentName)
        this.$store.commit('setFirstLogin', res.firstLogin)
        if (this.checkbox) {
          await bindWechat({ token: res.token, userId: res.userId, openId: this.openId })
        }
        // if (res.firstLogin === '0') {
        //   this.$router.push('/firstLoginPage')
        // } else {
        //   // const into = await IntoIndex()
        //   // window.open(into, '_self')
        //   this.$router.push('/index')
        // }
        this.$router.push('/index')
      }
    },
    // 微信登录接口
    async WechatLogin (e) {
      const { data: res } = await WechatLogin({ openId: this.$store.state.openId })
      if (e === 'click' && res.msg && res.msg.indexOf('微信未绑定微信登录') !== -1) return this.$toast.fail('该微信未绑定微信登录')
      if (e === 'first' && res.length && this.automaticLogin !== 'yes') {
        this.$store.commit('setAccountList', res)
        res.forEach(async (item, index) => {
          if (item.isAuto === '0') {
            this.$store.commit('setUserID', item.userId + 'a')
            this.$store.commit('setToken', item.token)
            this.$store.commit('setUserName', item.userName)
            this.$store.commit('setAgentName', item.agentName)
            // const into = await IntoIndex()
            // window.open(into, '_self')
            return this.$router.push('/Home')
          }
        })
      }
      if (res.length === 0 && e === 'click') return this.$toast('当前微信未绑定账号,请输入账号密码登录')
      if (res.length > 1 && e === 'click') {
        this.$store.commit('setAccountList', res)
        return this.$router.push('/switch')
      }
      if (res.length === 1 && e === 'click') {
        const { data: ress } = await WechatLogin({ openId: this.$store.state.openId, userId: res[0].userId })
        this.$store.commit('setUserID', ress[0].userId + 'a')
        this.$store.commit('setToken', ress[0].token)
        this.$store.commit('setUserName', ress[0].userName)
        this.$store.commit('setAgentName', ress[0].agentName)
        this.$store.commit('setFirstLogin', ress[0].firstLogin)
        this.$dialog.confirm({
          title: '提示',
          message: '将把该账号覆盖为当前微信自动登录账号'
        }).then(async () => {
          const { data: newRes } = await WechatLogins({ openId: this.$store.state.openId, userId: res[0].userId, isAuto: '0' })
          if (newRes.code !== 0) return this.$toast.fail('设置失败')
          this.$toast.success('自动登录设置成功')
          this.$store.commit('setIsAutoAccount', ress[0].userName)
          // if (ress[0].firstLogin === '0') {
          //   this.$router.push('/firstLoginPage')
          // } else {
          //   // const into = await IntoIndex()
          //   // window.open(into, '_self')
          //   this.$router.push('/index')
          // }
          this.$router.push('/index')
        }).catch(async () => {
          await WechatLogins({ openId: this.$store.state.openId, userId: res[0].userId, isAuto: '1' })
          // const into = await IntoIndex()
          // window.open(into, '_self')
          this.$router.push('/index')
        })
      }
    },
    // 处理openid获取判断条件
    getFindeOpenId () {
      if (!this.openId) {
        // location.href = process.env.VUE_APP_DOMAIN+'/#/getOpenId'
        this.$router.push('/getOpenId')
      } else {
        this.WechatLogin('first')
      }
    },
    // 处理 获取openid 的 code
    getQueryString (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const result = window.location.search.substring(1).match(reg)
      if (result != null) {
        return decodeURIComponent(result[2])
      }
      return null
    },
    // 获取带有 code 的网址
    async gotoAuth () {
      const time = new Date().getTime() + Math.random().toFixed(6).slice(-6) + ''
      const { data: ress } = await AuthorizeMobile({
        returnUrl: location.href,
        state: time
      })
      if (ress !== '获取失败') {
        location.href = ress
      }
    },
    // 获取初始化参数
    async getInfo (code) {
      const { data: ress } = await userInfoMobile({
        code: code,
        state: location.href
      })
      // console.log(ress)
      // window.localStorage.setItem('TOKSCSAC', ress)
      if (ress.code === 1) return
      this.openid = ress.openId
      this.userFOM.headImgUrl = ress.headImgUrl
      this.userFOM.nickname = ress.nickname
      this.$store.commit('setOpenId', ress.openId)
      this.$store.commit('setIsAccessToken', this.userFOM)
      this.$store.commit('setVersionTime', new Date().getTime())
      this.$store.commit('setIsFirst', '1')
      this.getconfig()
    },
    // 初始化
    async getconfig () {
      const urlThis = location.href.split('#')[0]
      const { data: res } = await initConfig({
        url: urlThis
      })
      if (res) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          jsApiList: [
            'chooseWXPay',
            'updateAppMessageShareData',
            'updateTimelineShareData'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      }
    },
    judgeAppEdition () {
      const that = this
      // const Timestamp = new Date().getTime()
      getAppEdition().then(({ data: res }) => {
        localStorage.setItem('AppEdition', res.version)
        localStorage.setItem('OPENID', '')
        that.$store.commit('setOpenId', '')
        // if (localStorage.getItem('AppEdition') && localStorage.getItem('AppEdition') === res.version) {
        //   if (!that.$store.state.openId) {
        //     location.href = process.env.VUE_APP_DOMAIN + '?Edition=' + Timestamp + '/#/getOpenId'
        //   }
        // } else {
        //   localStorage.clear()
        //   localStorage.setItem('AppEdition', res.version)
        //   localStorage.setItem('OPENID', '')
        //   that.$store.commit('setOpenId', '')
        //   location.href = process.env.VUE_APP_DOMAIN + '?Edition=' + Timestamp + '/#/getOpenId'
        // }
      }).then(res => {
        that.isFirst = that.$store.state.isFirst ? that.$store.state.isFirst : ''
        that.automaticLogin = that.$store.state.signOut ? that.$store.state.signOut : 'no'
        that.tsTitle = true
        // that.openId = that.$store.state.openId ? that.$store.state.openId : ''
        // if (that.$store.state.openId) {
        //   that.tsTitle = true
        //   that.WechatLogin('first')
        // }
        // oDnaT1M3yGLgdoq9iJrlI1AYz3RQ oDnaT1KcYJTxL7HpelMSBhT9cXyo
        // that.openId = 'oDnaT1M3yGLgdoq9iJrlI1AYz3RQ'
        // that.$store.commit('setOpenId', 'oDnaT1M3yGLgdoq9iJrlI1AYz3RQ')
        // that.getFindeOpenId()
        // that.tsTitle = true
      })
    }
  },
  beforeCreate () {
  },
  created () {
    this.judgeAppEdition()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .about {
    text-align: center;
    header {
      width: 400px;
      margin: 0 auto;
      img {
        margin-top: 50px;
        margin-bottom: 50px;
        width: 100%;
      }
    }
    .cxcz {
      padding: 0 24px;
      h3 {
        text-align: center;
        line-height: 83px;
        font-size: 40px;
        color: #666666;
        font-weight: 400;
        margin-top: -10px;
      }
    }
    .other {
      position: absolute;
      bottom: 0;
      width: 100%;
      background-color: #f0f6ff;
      height: 125px;
      .btns {
        height: 100%;
        display: flex;
        padding: 0 20px;
        justify-content: space-between;
        align-items: center;
        .Weact {
          display: flex;
          align-items: center;
          p {
            color: rgb(82, 82, 82);
            font-size: 30px;
          }
          .wx {
            background: url('../../assets/second-2.png') no-repeat;
            background-size: 100%;
            width: 50px;
            height: 50px;
          }
        }
        .register {
          display: flex;
          align-items: center;
          font-size: 30px;
          color: #1989fa;
          cursor: pointer;
        }
      }
    }
    .vanBTNS {
      margin: 32px 15px 16px;
    }
    .btnDown {
      padding-left: 20px;
      text-align: left;
      font-size: 30px;
      color: rgb(32, 136, 233);
    }
  }
</style>
